import { useEffect, useState } from 'react';

export const useSkeletonDelay = (loading: boolean, delay = 250) => {
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    let timer: any;

    if (loading) {
      timer = setTimeout(() => setShowSkeleton(true), delay);
    } else {
      setShowSkeleton(false);
    }

    return () => clearTimeout(timer);
  }, [loading, delay]);

  return showSkeleton;
};
